import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[idInput]',
})
export class IdInputDirective {
  idList = output<number[]>();

  @HostListener('input', ['$event']) onInput(event: any) {
    event.target.value = event.target.value.replace(/[^0-9,-]/g, '');
    this.idList.emit(this.parseStringToIdList(event.target.value));
  }

  parseStringToIdList(str: string): number[] {
    if (!str?.length) {
      return [];
    }
    const split = str.split(',');
    return split.flatMap((s) => {
      if (!s) {
        return [];
      }
      if (s.includes('-')) {
        const rangeSplit = s.split('-');
        const rangeLeft = Number(rangeSplit[0]);
        const rangeRight = Number(rangeSplit[1]);
        if (isNaN(rangeLeft) || isNaN(rangeRight) || rangeLeft >= rangeRight) {
          return [];
        }
        return Array.from(Array(rangeRight + 1 - rangeLeft).keys()).map((n) => n + rangeLeft);
      }
      const n = Number(s);
      if (isNaN(n)) {
        return [];
      }
      return [n];
    });
  }
}
